export default "__VITE_ASSET__C95H3Gq5__"